import {useEffect, useState,useContext} from "react";
import {useHistory} from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import {makeStyles} from "@material-ui/core/styles";
import {GeneralesContext} from '../context/GeneralesContext'
import { Box, Button, Card, CardContent, FormControl, Grid,
    IconButton, InputLabel, LinearProgress, Paper, Select, Tooltip,
    Typography,} from "@material-ui/core";
import TablaRecorridos from "./TablaRecorridos";
import Relojes from "./Relojes";
import axios from "axios";
import qs from "qs";
import {ErrorGeneral, llamaApiCargaToken,} from "../funciones/ClienteAxios";
import Galeria from "./Galeria";
import {AddCircleOutlined} from "@material-ui/icons";
import ModalAgregarRecorrido from "./ModalNvoEdit";
import ModalAgregarEvidencia from "./ModalAgregarEvidencia";

const useStyles = makeStyles((theme) => ({}));

const Recorrido = () => {
    const classes = useStyles();
    const idusu = localStorage.getItem("UsuId");
    const history = useHistory();
    const source = axios.CancelToken.source();

    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
        inicio: new Date(),
        final: new Date(),
    });
    const {generales, guardarGenerales} = useContext(GeneralesContext); 
    const [recorrido, setRecorrido] = useState([]);
    const [galeria, setGaleria] = useState([]);
    const [latitud, setLatitud] = useState(0);
    const [longitud, setLongitud] = useState(0);
    const [cargando, setCargando] = useState(false);
    const [abrirModalMapa, setAbrirModalMapa] = useState(false);
    const [abrirModalAgregar, setAbrirModalAgregar] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [listTipo, setListTipo] = useState([]);
    const [buscar, setBuscar] = useState(true);
    const [checked, setChecked] = useState(false);
    const [abrirModal, setAbrirModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [tipo, setTipo] = useState("");
    const [Distrito,  setDistrito]=useState("")
    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setLatitud(position.coords.latitude);
                setLongitud(position.coords.longitude);
            });
        } else {
           // console.log("Not Available");
            setLatitud(0);
            setLongitud(0);
        }
        getListTipo()
        guardarGenerales({...generales, Titulo: 'Recorridos'})
    }, []);


    useEffect(() => {
        setGaleria([]);

        const consultarImagenes = () => {
            const data = qs.stringify({
                Llave: recorrido.Id,
                Usuario: idusu,
                idDispositivo: "987gyubjhkkjh",
            });
            const url = "recorrido-file-list";

            function respuesta(response) {
                if (response[0].Id === -1) {
                    setGaleria([]);
                    setMensaje("Sin fotografías.");
                } else {
                    setGaleria(response);
                }
            }

            llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
        };
        if (recorrido !== null) {
            consultarImagenes();
        }
    }, [recorrido,update]);

    const getListTipo = () => {
        const data = qs.stringify({            
            Usuario: idusu,
            idDispositivo: "987gyubjhkkjh",
        });
        const url = "recorrido-tipo";

        function respuesta(response) {
            if (response[0].Id === -1) {
                setListTipo([]);
                
            } else {
                setListTipo(response);
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
    };

    const buscarDatos = () => {
        setBuscar(!buscar)
    }

    const modalAgregarEvidencia = abrirModal ? <ModalAgregarEvidencia abrirModal={abrirModal}
                                                setAbrirModal={setAbrirModal} recorrido={recorrido}
                                                idusu={idusu}  setUpdate={setUpdate}
                                            /> : null

    const modalAgregarRecorrido = abrirModalAgregar ? <ModalAgregarRecorrido abrirModal={abrirModalAgregar}
                                                        setAbrirModal={setAbrirModalAgregar}
                                                        idusu={idusu}  latitud={latitud}
                                                        longitud={longitud} actualiza={buscarDatos}
                                                    /> : null

    const agregarDatos = () => {
        setAbrirModalAgregar(true)
    }

    const listarGaleria =
        galeria.length > 0 ? (
            <Galeria
                galeria={galeria}
            />
        ) : (
            <Paper className={classes.root}>
                <Typography variant={"h5"}>{mensaje}</Typography>
            </Paper>
        );

    const handleChange = () => {
        setChecked(!checked)
    };

    const handleAbrir = () => {
        setAbrirModal(true)
    }
    
    const onChange = e => {
        setTipo( e.target.value)
    }

    const principal = () => {
        return (
            <Grid container spacing={1}>
                {modalAgregarRecorrido}
                <Grid item xs={12}>
                    <Card>
                        <CardContent style={{padding:0.4+'rem'}} >
                            <Grid container spacing={1} alignItems={'center'}>
                                <Grid item>
                                     
                                    <Button onClick={buscarDatos} style={{width:"7rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                                        variant="contained"  color="primary"  startIcon={<SearchIcon/>} >   
                                        Buscar     
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Relojes
                                        fechasSeleccionadas={fechasSeleccionadas}
                                        setFechasSeleccionadas={setFechasSeleccionadas}
                                    />
                                </Grid>
                                <Grid item >
                                    {listTipo.length !== 0 ?
                                    <FormControl size="small">
                                        <InputLabel htmlFor="Tipo">Tipo</InputLabel>
                                        <Select native value={tipo}   onChange={onChange}
                                            inputProps={{name: 'tipo', id: 'tipo',}} style={{width:"15rem"}}
                                        >
                                            {listTipo.map(element => {
                                                return <option key={element.Id} value={element.Id}>
                                                    {element.Nom}</option>
                                            })}
                                        </Select>
                                    </FormControl>
                                    : null
                                    }
                                </Grid>
                                {/* <Grid item>
                                    <FormControlLabel
                                        value={checked}
                                        control={<Checkbox color="primary"/>}
                                        label="Buscar solo mis registros"
                                        labelPlacement="end"
                                        size={'small'}
                                        onChange={handleChange}
                                    />
                                </Grid> */}
                                 <Grid item>
                                    <Button onClick={agregarDatos} style={{width:"14rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                                        variant="contained"  color="primary"  startIcon={<AddCircleOutlined/>} >   
                                        Agregar Recorrido     
                                    </Button>
                                    
                                </Grid>
                                
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={8}>
                    <TablaRecorridos
                        history={history} setRecorrido={setRecorrido}
                        fechasSeleccionadas={fechasSeleccionadas}             
                        source={source} idusu={idusu} buscar={buscar}
                        checked={checked} abrirModal={abrirModalMapa}
                        setAbrirModal={setAbrirModalMapa} Distrito={Distrito}
                        tipo={tipo} latitud={latitud}  longitud={longitud} 
                    />
                </Grid>
                <Grid item xs={4}>
                    {modalAgregarEvidencia}
                    {recorrido.Obsrv ? 
                        cargando ? (
                            <Box mt={2} mb={2} width="80%">
                                <LinearProgress/>
                            </Box>
                        ) 
                        : (
                            <Grid container>
                            <Grid item xs={12} style={{paddingBottom: 10}}>
                                <Typography color="primary">
                                    Observación
                                </Typography>
                                <Typography>
                                    {recorrido?.Obsrv}
                                </Typography>
                            </Grid>
                            </Grid>
                        ) 
                    :null}
                    {recorrido.Direcc ? 
                        cargando ? (
                            <Box mt={2} mb={2} width="80%">
                                <LinearProgress/>
                            </Box>
                        ) 
                        : (
                            <Grid container>
                            <Grid item xs={12} style={{paddingBottom: 10}}>
                                <Typography color="primary">
                                    Dirección
                                </Typography>
                                <Typography>
                                    {recorrido?.Direcc}
                                </Typography>
                            </Grid>
                            </Grid>
                        ) 
                    :null}
                    {recorrido !== null ? <Grid container>
                        <Grid item xs={12} style={{paddingBottom: 10}}>
                            <Button
                                variant="contained" color="primary"
                                startIcon={<AddCircleOutlined/>}
                                onClick={handleAbrir}
                            >
                                Subir Fotos
                            </Button>
                        </Grid>
                    </Grid> : null}
                    {cargando ? (
                        <Box pl={1} pt={5}>
                            <LinearProgress/>
                        </Box>
                    ) : (
                        listarGaleria
                    )}
                </Grid>
            </Grid>
        );
    };

    return <div>{principal()}</div>;
};

export default Recorrido;
